exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".toolbox {\n  bottom: 0px;\n  background: #edf3f7;\n  width: 100%;\n  position: absolute;\n  opacity: 0.85;\n  margin-left: -2rem;\n  z-index: 999;\n}\n.toolbox .toolbox-controls.right {\n  float: right;\n  padding-right: 2rem;\n}\n.toolbox .toolbox-controls.left {\n  float: left;\n  padding-left: 2rem;\n}\n.toolbox .toolbox-controls .toolbox-button {\n  margin: 0.55rem;\n}\n.toolbox:hover {\n  opacity: 1;\n}\n.student-list-grid-component {\n  margin-bottom: 8rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/components/main.less
// module id = 4060
// module chunks = 0